import React, { useState } from "react"
import i18n from "@/i18n"
import styled from "styled-components"

const Section = styled.section`
    background-color: #fff;
    display: flex;
    width: 900px;
    max-width: 100%;
    flex-direction: column;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
`

const LogoWrapper = styled.div`
    border-radius: 7px;
    background-color: #3d3d3d;
    display: flex;
    width: 48px;
    height: 48px;
    align-items: center;
    justify-content: center;
`

const LogoImage = styled.img`
    aspect-ratio: 1.12;
    object-fit: contain;
    width: 100%;
    border-radius: 12px;
`

const Content = styled.div`
    display: flex;
    margin-top: 16px;
    flex-direction: column;
    align-items: center;
`

const Title = styled.h1`
    color: #83c308;
    font-size: 34px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -0.68px;
    text-align: center;
  
    .highlight-text {
      color: #515151;
    }
`

const Description = styled.p`
    color: #515151;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.32px;
    margin-top: 10px;
`

const TemplateItemWrapper = styled.article`
    border-radius: 10px;
    background-color: #515151;
    display: flex;
    min-width: 206px;
    max-width: 206px;
    min-height: 336px;
    max-height: 336px;
    flex-direction: column;
    overflow: hidden;
    justify-content: end;
    flex: 1;
    flex-basis: 0%;
    cursor: pointer;

    transition: 0.5s;
    &:hover {
        transform: scale(1.05);
    }
`

const TemplateThumbnail = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
`

const TemplateVideo = styled.video`
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
    border-radius: 8px;
`

const TemplateWrapper = styled.section`
    background-color: #fff;
    display: flex;
    max-width: 100%;
    align-items: start;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
`

function TemplateItem({ id, thumbnail, src, onThumbnailClicked }) {
    const [isLoaded, setIsLoaded] = useState(false)
    return (
        <TemplateItemWrapper
            onClick={onThumbnailClicked(id)}
        >
            <TemplateVideo
                src={src}
                muted
                autoPlay
                loop
                playsInline
                webkit-playsinline
                onLoadedData={() => {
                    setIsLoaded(true)
                }}
            />
            <TemplateThumbnail
                style={{
                    display: isLoaded ? "none" : "block"
                }}
                src={thumbnail}
            />
        </TemplateItemWrapper>
    )
}

export default function VerticalTemplateArea({ onThumbnailClicked, lang }) {
    const templates_ko = [
        {
            "id": "66dacb61bd5c7d3be678dbb1",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/66dacb61bd5c7d3be678dbb1.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/66dacb61bd5c7d3be678dbb1.mp4"
        },
        {
            "id": "6228b6b6f0a7200350019ed0",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/6228b6b6f0a7200350019ed0.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/6228b6b6f0a7200350019ed0.mp4"
        },
        {
            "id": "64fae54b9f720400609b36ba",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/64fae54b9f720400609b36ba.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/64fae54b9f720400609b36ba.mp4"
        },
        {
            "id": "667543189161d30793a21c03",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/667543189161d30793a21c03.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/667543189161d30793a21c03.mp4"
        },
        {
            "id": "657c92bb3b57062c5a4b0a94",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/657c92bb3b57062c5a4b0a94.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/657c92bb3b57062c5a4b0a94.mp4"
        },
        {
            "id": "61317acc9eaaac05d6b963aa",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/61317acc9eaaac05d6b963aa.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/61317acc9eaaac05d6b963aa.mp4"
        },
    ]
    const templates_en = [
        {
            "id": "61317acc9eaaac05d6b963aa",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/61317acc9eaaac05d6b963aa_en.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/61317acc9eaaac05d6b963aa_en.mp4"
        },
        {
            "id": "6228b6b6f0a7200350019ed0",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/6228b6b6f0a7200350019ed0_en.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/6228b6b6f0a7200350019ed0_en.mp4"
        },
        {
            "id": "64fae54b9f720400609b36ba",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/64fae54b9f720400609b36ba_en.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/64fae54b9f720400609b36ba_en.mp4"
        },
        {
            "id": "657c92bb3b57062c5a4b0a94",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/657c92bb3b57062c5a4b0a94_en.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/657c92bb3b57062c5a4b0a94_en.mp4"
        },
        {
            "id": "667543189161d30793a21c03",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/667543189161d30793a21c03_en.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/667543189161d30793a21c03_en.mp4"
        },
        {
            "id": "66dacb61bd5c7d3be678dbb1",
            "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/66dacb61bd5c7d3be678dbb1_en.jpg",
            "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/vertical/241206_01/66dacb61bd5c7d3be678dbb1_en.mp4"
        }
    ]
    const templates = lang === "ko" ? templates_ko : templates_en
    return (
        <>
            <Section>
                <LogoWrapper>
                    <LogoImage loading="lazy" src="https://front.videomonster.com/images-u6yd72dy/common/newlanding2024/videomonster_icon.png" alt="VideoMonster Logo" />
                </LogoWrapper>
                <Content>
                    <Title>
                        <span className="highlight-text">{i18n.t("common.landing.template.area.title")}</span> {i18n.t("common.landing.top.banner.videomonster")}
                    </Title>
                    <Description>
                        {i18n.t("common.landing.template.area.text")}
                    </Description>
                </Content>
            </Section>
            <TemplateWrapper>
                {templates.map(item => (
                    <TemplateItem
                        id={item.id}
                        thumbnail={item.thumbnail}
                        src={item.src}
                        onThumbnailClicked={onThumbnailClicked}
                    />
                ))}
            </TemplateWrapper>
        </>
    )
}